/*
 *  -----------------------------------------------------------------------
 *    <copyright file="admin-study-crfs-grid.data.ts" company="Triumph Research Intelligence">
 *        Copyright (C) 2023 by Triumph Research Intelligence. All rights reserved.
 *    </copyright>
 *   -----------------------------------------------------------------------
 *
 */

import { GridColumnDateFilter, GridColumnMenuActiveFilter } from '../../core/grid-filters';
import { useGridCells } from '../../../../hooks';

const { YesNoCell, NumberCell, DateCell, MaxLengthCell } = useGridCells();

export const ADMIN_STUDY_CRFS_COLUMNS = (translate: Function) => [
    {
        field: 'subjectCode',
        id: 'crf-subjectCode',
        label: translate('admin:formId'),
        lockedByDefault: true,
        minWidth: 140,
        cells: { data: MaxLengthCell(50) },
    },
    {
        field: 'crfName',
        id: 'crf-crfName',
        label: translate('common:name'),
        lockedByDefault: true,
        minWidth: 140,
        cells: { data: MaxLengthCell(50) },
    },
    {
        field: '_crfRules',
        id: 'crf-additional-rules',
        label: translate('ra:additionalRules'),
        minWidth: 155,
        cells: { data: MaxLengthCell(50) },
    },
    {
        field: 'required',
        id: 'crf-required',
        label: translate('ra:required'),
        minWidth: 155,
        cells: { data: YesNoCell },
        filterUi: GridColumnMenuActiveFilter,
    },
    {
        field: 'active',
        id: 'crf-active',
        label: translate('admin:active'),
        minWidth: 155,
        cells: { data: YesNoCell },
        filterUi: GridColumnMenuActiveFilter,
    },
    {
        field: '_assessments',
        id: 'crf-assessments',
        label: translate('admin:assessmentS'),
        minWidth: 200,
        cells: { data: MaxLengthCell(50) },
    },
    {
        field: '_createdByString',
        id: 'crf-createdby',
        label: translate('ra:createdBy'),
        minWidth: 180,
    },
    {
        field: 'created',
        id: 'crf-created',
        label: translate('ra:createdDate'),
        minWidth: 200,
        cells: { data: DateCell },
        filterUi: GridColumnDateFilter,
    },
    {
        field: '_updatedByString',
        id: 'crf-updatedby',
        label: translate('ra:updatedBy'),
        minWidth: 180,
    },
    {
        field: 'updated',
        id: 'crf-updated',
        label: translate('ra:updatedDate'),
        minWidth: 200,
        filterUi: GridColumnDateFilter,
        cells: { data: DateCell },
    },
    {
        field: 'recordId',
        id: 'crf-id',
        label: translate('id'),
        showByDefault: false,
        minWidth: 120,
        filter: 'numeric',
        cells: { data: NumberCell },
    },
];
